import processHtmlAttributes from "../../common/html-attributes"

static var ignoredAttributes = [
    "icon",
    "disabled",
    "pointer",
    "styleTop",
    "styleLeft",
    "styleRight",
    "styleBottom",
    "ariaLabel",
    "a11yCloseText",
    "host",
    "heading",
    "content",
    "variant"
];

$ var isModal = input.variant === 'modal'
$ var classPrefix = !isModal ? "infotip" : "dialog--mini";
$ var pointer = input.pointer || "bottom";
<span>
    <ebay-tooltip-base
        key="base"
        type=classPrefix
        pointer=pointer
        overlay-id:scoped="overlay"
        onBase-expand(!isModal && "handleExpand")
        onBase-collapse(!isModal && "handleCollapse")>
        <span
            ...processHtmlAttributes(input, ignoredAttributes)
            class:no-update=[
                "infotip",
                isModal === true && "dialog--mini",
                input.class
            ]>
            <button
                key="host"
                class=[`${classPrefix}__host`, "icon-btn"]
                type="button"
                on-click(isModal && "handleExpand")
                disabled=input.disabled
                aria-label=input.ariaLabel>
                <if(input.icon)>
                    <${input.icon}/>
                </if>
                <else>
                    <ebay-information-icon/>
                </else>
            </button>
            <if(isModal !== true)>
                <ebay-tooltip-overlay
                    type="infotip"
                    id:scoped="overlay"
                    style-left=input.styleLeft
                    style-top=input.styleTop
                    style-right=input.styleRight
                    style-bottom=input.styleBottom
                    pointer=pointer
                    heading=input.heading
                    content=input.content
                    a11y-close-text=input.a11yCloseText
                    onOverlay-close("handleOverlayClose")/>
            </if>
            <else>
                <ebay-lightbox-dialog
                    open=state.open
                    class=[`${classPrefix}__overlay`]
                    variant="_mini"
                    a11y-close-text=input.a11yCloseText
                    on-open("handleExpand")
                    on-close("handleCollapse")
                    aria-label=input.ariaLabel>
                    <${input.content}/>
                </ebay-lightbox-dialog>
            </else>
        </span>
    </ebay-tooltip-base>
</span>
